/**
 * @param {object} state
 * @returns {import('../../financial-services-ui/types/fsui').AccountSimple}
 */
export const selectAccountInformation = (state) => state;

/**
 * @param {object} state
 * @returns {boolean}
 */
export const selectIsWalletApBacked = (state) => state?.isWalletCreatedAfterAPLaunch;
